<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">公司名称</p>
<!--        <el-input v-model="companyName" placeholder="请输入" clearable class="inputDiv"></el-input>-->
        <el-select v-model="companyId" placeholder="请选择" class="inputDiv" clearable>
          <el-option
              v-for="item in companyValueList"
              :key="item.companyId"
              :label="item.companyName"
              :value="item.companyId">
          </el-option>
        </el-select>
      </div>
      <div class="stateDiv">
        <p class="searchText">开户行</p>
        <el-input v-model="openingBank" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <el-button class="searchBtn" type="primary" @click="getData()">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addAccount()">新增账户</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <el-table
            v-loading="loading"
            :data="tableData"
            :default-sort = "{prop: 'id', order: 'descending'}"
            style="width: 100%"
            :highlight-current-row="false"
            :header-cell-style="{background:'#F4F7FA',color:'#606266'}">
          <template v-for="(item, index) in tableColumns">
<!--            <el-table-column-->
<!--                v-if="item.prop === 'companyId'"-->
<!--                :key="index"-->
<!--                :prop="item.prop"-->
<!--                :label="item.label"-->
<!--                :width="item.width">-->
<!--              <template slot-scope="scope">-->
<!--                <div>-->
<!--                  {{getNameById(scope.row.companyId) || '&#45;&#45;'}}-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                v-else-if="item.prop === 'companyAddress'"-->
<!--                :key="index"-->
<!--                :prop="item.prop"-->
<!--                :label="item.label"-->
<!--                :width="item.width">-->
<!--              <template slot-scope="scope">-->
<!--                <div>-->
<!--                  {{getAddrById(scope.row.companyAddress) || '&#45;&#45;'}}-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :formatter="item.formatter"
                :width="item.width">
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope" class="tableButton">
              <el-button class="tableBtn" @click="viewOrHandle(scope.row)" type="text" size="small">编辑</el-button>
              <el-button class="tableBtn" @click="deleteFun(scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
          class="paginationBody">
      </el-pagination>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog
          :title="eventControl"
          :visible.sync="dialogFormVisible"
          :before-close="closeAdd"
          center
      >
        <el-form ref="addForm" :model="addForm" :rules="rules">
          <el-form-item label="公司名称" label-width=".90rem" prop="companyId" class="formItem">
            <el-select v-model="addForm.companyId" placeholder="请输入" class="inputDiv" clearable>
              <el-option
                  v-for="item in companyValueList"
                  :key="item.companyId"
                  :label="item.companyName"
                  :value="item.companyId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司地址" label-width=".90rem" prop="address" class="formItem">
            <el-input v-model="addForm.address" disabled></el-input>
          </el-form-item>
          <el-form-item label="开户行" label-width=".90rem" prop="bank" class="formItem">
            <el-input v-model="addForm.bank"></el-input>
          </el-form-item>
          <el-form-item label="账号" label-width=".90rem" prop="account" class="formItem">
            <el-input v-model="addForm.account"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAdd()">取 消</el-button>
          <el-button type="primary" @click="addEventForm()">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { addCompanyBank, queryCompanyBank, queryIdCompanyBank, updateCompanyBank, deleteCompanyBank } from '@/api/basicInfo'
import { listCompanyfInfo } from '@/api/searchList'
import { Message } from 'element-ui'

export default {
  name: 'companyAccount',
  data () {
    return {
      loading: false,
      roleValue: '',
      roleValueList: [],
      companyValueList: [],
      stateValue: '',
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      companyId: '',
      openingBank: '',
      id: '',
      addForm: {
        companyId: '',
        address: '',
        bank: '',
        account: ''
      },
      rules: {
        companyId: [{ required: true, message: '请填写', trigger: 'blur' }],
        address: [{ required: true, message: '请填写', trigger: 'blur' }],
        bank: [{ required: true, message: '请填写', trigger: 'blur' }],
        account: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      tableData: [],
      tableColumns: [
        {
          prop: 'companyName',
          label: '公司名称'
          // formatter: (row, column, v) => {
          //   return this.companyValueList.find(v1 => v1.companyId === v).companyName
          // }
        },
        {
          prop: 'companyAddr',
          label: '公司地址'
          // formatter: (row, column, v) => {
          //   return this.companyValueList.find(v2 => v2.companyId === v).companyAddr
          // }
        },
        {
          prop: 'openingBank',
          label: '开户行'
        },
        {
          prop: 'openingBankAccount',
          label: '账号'
        }
      ]
    }
  },
  watch: {
    // 选择所属公司后，对应公司地址
    'addForm.companyId': {
      handler (v) {
        if (v) {
          this.addForm.address = this.companyValueList.filter(i => i.companyId === v)[0].companyAddr
        } else {
          this.addForm.address = ''
        }
      },
      deep: true,
      immediate: false
    }
  },
  async mounted () {
    await this.getCompanyList()
    await this.getData()
  },
  methods: {
    getData () {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList () {
      let res = await queryCompanyBank({
        companyId: this.companyId,
        openingBank: this.openingBank,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    // 新增
    addAccount () {
      this.edit = false
      this.dialogFormVisible = true
      this.eventControl = '新增账户'
    },
    // 编辑
    async viewOrHandle (row) {
      this.edit = true
      this.eventControl = '编辑账户'
      let res = await queryIdCompanyBank({
        id: row.id
      })
      if (res.code === 0) {
        this.addForm.companyId = res.result.companyId
        this.addForm.bank = res.result.openingBank
        this.addForm.account = res.result.openingBankAccount
        this.id = row.id
      }
      this.dialogFormVisible = true
    },
    closeAdd () {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.addForm = {
        companyId: '',
        address: '',
        bank: '',
        account: ''
      }
    },
    // 所属公司-楼宇级联下拉框
    async getCompanyList () {
      let res = await listCompanyfInfo()
      if (res.code === 0) {
        this.companyValueList = res.result
      }
    },
    addEventForm () {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await updateCompanyBank({
              companyId: this.addForm.companyId,
              openingBank: this.addForm.bank,
              openingBankAccount: this.addForm.account,
              id: this.id
            })
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.dialogFormVisible = false
              this.$refs['addForm'].resetFields()
              this.addForm = {
                companyId: '',
                address: '',
                bank: '',
                account: ''
              }
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await addCompanyBank({
              companyId: this.addForm.companyId,
              openingBank: this.addForm.bank,
              openingBankAccount: this.addForm.account
            })
            if (res.code === 0) {
              Message.success('新增成功！')
              this.$refs['addForm'].resetFields()
              this.dialogFormVisible = false
              this.addForm = {
                companyId: '',
                address: '',
                bank: '',
                account: ''
              }
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除分组
    deleteFun (row) {
      this.$confirm('此操作将删除该公司账户信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await deleteCompanyBank(params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    },
    // 通过公司id获得对应公司名称
    getNameById (id) {
      let result
      for (let i of this.companyValueList) {
        if (i.companyId === id) {
          result = i.companyName
        }
      }
      return result
    },
    // 通过公司id获得对应公司地址
    getAddrById (id) {
      let result
      for (let i of this.companyValueList) {
        if (i.companyId === id) {
          result = i.companyAddr
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  .app-inner {
    width: 98%;
    height: 70vh;
    padding: 0.2rem;
    box-sizing: border-box;
  }
  .searchTitleDiv {
    width: 15rem;
    height: 0.66rem;
    margin-left: 0.2rem;
    margin-top: 0.05rem;
    /*display: flex;*/
    /*justify-content: space-around;*/

    .stateDiv {
      margin-top: 0.14rem;
      margin-left: .3rem;
      float: left;
    }

    .searchText {
      margin-top: 0.05rem;
      margin-right: 0.13rem;
      font-size: 0.2rem;
      color: #111111;
      float: left;
    }

    .inputDiv {
      width: 2.2rem;
      float: left;
    }

    .searchBtn {
      /*width: 1.20rem;*/
      /*height: 0.36rem;*/
      /*border-radius: 0.06rem;*/
      /*font-size: 0.18rem;*/
      margin-top: 0.14rem;
      margin-left: .3rem;
      /*padding-top: 0.1rem;*/
    }
  }
  .table{
    margin-top: .3rem;
    margin-left: .5rem;
    text-align: center;
    width: 14.8rem;
    .searchList{
    }
    .paginationBody{
      margin-top: .1rem;
    }
  }
  .formItem{
    width: 3.2rem;
  }
  /deep/ .el-dialog{
    width: 23%!important;
  }
</style>
